// extracted by mini-css-extract-plugin
export default {"formButton":"ButtonText_formButton__Vg5kk"};